import DSBox from "views/system-design/DSBox";
import PageHeader from "components/PageHeader";
import DSSegmentedTabs from "views/system-design/DSSegmentedTabs";
import useTabParam from "components/hooks/useTabParam";
import OnboardingSettings from "views/Onboarding/components/OnboardingSettings";
import StudioUpdates from "./StudioUpdates";
import StudioContractEditor from "./StudioContractEditor";
import StudioFaqEditor from "./StudioFaqEditor";
import StudioGuidesEditor from "./StudioGuidesEditor";
import StudioPlanManager from "./StudioPlanManager";

// URL values for each numeric tab index, derived from the tab labels
const TAB_URL_VALUES = [
  "onboarding",
  "updates",
  "contract",
  "faq",
  "guides",
  "plans",
] as const;

const StudioPage = () => {
  const [tabParam, setTabParam] = useTabParam(
    "tab",
    "onboarding",
    TAB_URL_VALUES,
  );
  const paramIndex = TAB_URL_VALUES.indexOf(
    tabParam as (typeof TAB_URL_VALUES)[number],
  );
  const activeTab = paramIndex >= 0 ? paramIndex : 0;

  return (
    <DSBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <PageHeader
        overline="People"
        title="Studio"
        subtitle="Artist studio onboarding, updates, contract, FAQ, guides, and plans."
        tabs={
          <DSSegmentedTabs
            options={[
              { label: "Onboarding", value: "onboarding" },
              { label: "Updates", value: "updates" },
              { label: "Contract", value: "contract" },
              { label: "FAQ", value: "faq" },
              { label: "Guides", value: "guides" },
              { label: "Plans", value: "plans" },
            ]}
            value={TAB_URL_VALUES[activeTab]}
            onChange={(newValue) => {
              if (newValue !== undefined) setTabParam(newValue);
            }}
          />
        }
      />
      <DSBox sx={{ flex: 1, overflow: "auto" }}>
        {activeTab === 0 && <OnboardingSettings />}
        {activeTab === 1 && <StudioUpdates />}
        {activeTab === 2 && <StudioContractEditor />}
        {activeTab === 3 && <StudioFaqEditor />}
        {activeTab === 4 && <StudioGuidesEditor />}
        {activeTab === 5 && <StudioPlanManager />}
      </DSBox>
    </DSBox>
  );
};

export default StudioPage;
